import { type FC } from 'react';

import { useListingAppContext } from '@/microfrontends/listing/shared/context/ListingAppContext';
import { useListingContext } from '@/microfrontends/listing/shared/context/ListingContext';
import { useInitCardApi } from '@/microfrontends/listing/shared/hooks/useInitCardApi';

import { type AdfoxBannersConfig } from '@/packages/adfox';

import { Cards } from '../listing-cards/CardsWithAds';

export const ListingCardsContainer: FC = () => {
  const {
    adfox,
    listingProperties: { dealType },
    offers,
  } = useListingContext();
  const { config } = useListingAppContext();
  const adfoxConfig = config.getStrict<AdfoxBannersConfig>('search-frontend.adfox.pParams');

  const initCardApi = useInitCardApi();

  return (
    <Cards adfox={adfox} adfoxConfig={adfoxConfig} dealType={dealType} initCardApi={initCardApi} offers={offers} />
  );
};
